/* eslint-disable max-len */
const React = require('react');

const OnlinePaymentsPaymentLink = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="47" height="40" viewBox="0 0 47 40">
    <g fill="none" fillRule="evenodd" stroke="#009EE3" strokeWidth="1.6">
      <rect width="36.4" height="28.4" x=".8" y=".8" rx="3" transform="translate(0 4)" />
      <path d="M17.398 20.602c2.976 2.976 5.26.692 8.078-2.126 2.818-2.818 5.102-5.102 2.126-8.078-2.976-2.976-5.26-.692-8.078 2.126-2.818 2.818-5.102 5.102-2.126 8.078z" />
      <path d="M11.398 26.602c2.976 2.976 5.26.692 8.078-2.126 2.818-2.818 5.102-5.102 2.126-8.078-2.976-2.976-5.26-.692-8.078 2.126-2.818 2.818-5.102 5.102-2.126 8.078z" />
      <path fill="#FFF" d="M27 24l9 12 2.297-5.496L42 27z" />
      <path d="M39 31l7 4" />
    </g>
  </svg>
);

module.exports = OnlinePaymentsPaymentLink;
